module.exports = __webpack_public_path__ + "static/img/upper_normal.eb89f3a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/upper_normal.svg
// module id = 542
// module chunks = 0